'use strict';

var _defineProperty = require("/Users/challen/code/element-tracker/example/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var runtypes = require('runtypes');

var PingMessage = runtypes.Record({
  type: runtypes.Literal("ping"),
  nonce: runtypes.Number
});
var PongMessage = runtypes.Record({
  type: runtypes.Literal("pong"),
  nonce: runtypes.Number
});
var PingPongMessages = runtypes.Union(PingMessage, PongMessage);
var PingPongOptions = runtypes.Partial({
  interval: runtypes.Number,
  timeout: runtypes.Number,
  verbose: runtypes.Boolean
});
var pingPongDefaultOptions = {
  interval: 8000,
  timeout: 1000,
  verbose: false
};

function PongWS(ws) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _pingPongDefaultOptio = _objectSpread(_objectSpread({}, pingPongDefaultOptions), o),
      interval = _pingPongDefaultOptio.interval,
      timeout = _pingPongDefaultOptio.timeout,
      verbose = _pingPongDefaultOptio.verbose;

  var pongTimer;
  var nonce;
  var pongTimeout;

  function startPongTimer() {
    pongTimer = setInterval(function () {
      if (pongTimeout) {
        clearTimeout(pongTimeout);
      }

      nonce = Math.floor(Math.random() * 1024 * 1024);

      if (verbose) {
        console.log("-> pong ".concat(nonce));
      }

      ws.send(JSON.stringify(PongMessage.check({
        type: "pong",
        nonce: nonce
      })));
      pongTimeout = setTimeout(function () {
        ws.close();
      }, timeout);
    }, interval);
  }

  if (ws.readyState === ws.OPEN) {
    startPongTimer();
  } else {
    ws.addEventListener("open", startPongTimer);
  }

  ws.addEventListener("message", function (_ref) {
    var data = _ref.data;
    var message = JSON.parse(data);

    if (PongMessage.guard(message) && message.nonce === nonce && pongTimeout) {
      if (verbose) {
        console.log("<- pong ".concat(nonce));
      }

      clearTimeout(pongTimeout);
    } else if (PingMessage.guard(message)) {
      ws.send(data);
    }
  });
  ws.addEventListener("close", function () {
    if (pongTimer) {
      clearInterval(pongTimer);
    }

    if (pongTimeout) {
      clearTimeout(pongTimeout);
    }
  });
  return ws;
}

function PingWS(ws) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _pingPongDefaultOptio2 = _objectSpread(_objectSpread({}, pingPongDefaultOptions), o),
      interval = _pingPongDefaultOptio2.interval,
      timeout = _pingPongDefaultOptio2.timeout,
      verbose = _pingPongDefaultOptio2.verbose;

  var pingTimer;
  var nonce;
  var pingTimeout;

  function startPingTimer() {
    pingTimer = setInterval(function () {
      if (pingTimeout) {
        clearTimeout(pingTimeout);
      }

      nonce = Math.floor(Math.random() * 1024 * 1024);

      if (verbose) {
        console.log("-> ping ".concat(nonce));
      }

      ws.send(JSON.stringify(PingMessage.check({
        type: "ping",
        nonce: nonce
      })));
      pingTimeout = setTimeout(function () {
        ws.close();
      }, timeout);
    }, interval);
  }

  if (ws.readyState === ws.OPEN) {
    startPingTimer();
  } else {
    ws.addEventListener("open", startPingTimer);
  }

  ws.addEventListener("message", function (_ref2) {
    var data = _ref2.data;
    var message = JSON.parse(data);

    if (PingMessage.guard(message) && message.nonce === nonce && pingTimeout) {
      if (verbose) {
        console.log("<- ping ".concat(nonce));
      }

      clearTimeout(pingTimeout);
    } else if (PongMessage.guard(message)) {
      ws.send(data);
    }
  });
  ws.addEventListener("close", function () {
    if (pingTimer) {
      clearInterval(pingTimer);
    }

    if (pingTimeout) {
      clearTimeout(pingTimeout);
    }
  });
  return ws;
}

function filterPingPongMessages(listener) {
  return function (event) {
    try {
      var message = JSON.parse(event.data);

      if (PingPongMessages.guard(message)) {
        return;
      }
    } catch (err) {}

    return listener(event);
  };
}

exports.PingPongMessages = PingPongMessages;
exports.PingPongOptions = PingPongOptions;
exports.PingWS = PingWS;
exports.PongWS = PongWS;
exports.filterPingPongMessages = filterPingPongMessages;
exports.pingPongDefaultOptions = pingPongDefaultOptions;